export default {
  // Navigation
  nav_categories: 'Kategorien',
  nav_guides: 'Leitfäden',
  nav_article: 'SEO-Artikel',
  nav_spreadsheet: 'CSSBuy Spreadsheet',
  nav_lang: 'DE',
  nav_home: 'Startseite',
  nav_guide: 'Einkaufsführer',
  search_placeholder: 'Kategorie suchen...',
  related_content: 'Verwandte Inhalte',
  back_to_home: 'Zurück zur Startseite',
  visit_main_site: 'Hauptwebsite besuchen',
  more_articles: 'Weitere Artikel',

  // Hero
  hero_title: 'CSSBuy Spreadsheet – Produkte, Leitfäden und Ressourcen für Einkäufe in China',
  hero_subtitle: 'Entdecken Sie eine unabhängige und organisierte Ressource über CSSBuy Spreadsheet mit Produktkategorien, Einkaufsleitfäden, QC-Informationen, Versanddetails und Sicherheitstipps, um Ihre Recherche vor dem Kauf zu verbessern.',
  hero_cta_primary: 'CSSBuy Spreadsheet',
  hero_cta_secondary: 'Buy It Now',
  hero_trust_1: 'Unabhängige Ressource',
  hero_trust_2: 'Praktische Leitfäden',
  hero_trust_3: 'Organisierte Informationen',
  hero_trust_4: 'Regelmäßig aktualisiert',

  // What Is Section
  what_is_title: 'Was ist CSSBuy Spreadsheet?',
  what_is_text: 'CSSBuy Spreadsheet ist eine praktische Möglichkeit, Produkte, Links und Informationen im Zusammenhang mit dem Einkaufsforschungsprozess zu organisieren und zu entdecken. Sie können Kategorien und organisierte Ressourcen erkunden, um Ihre Recherche zu erleichtern.',
  what_is_cta: 'CSSBuy Spreadsheet erkunden',

  // Categories
  categories_title: 'Produktkategorien',
  categories_subtitle: 'Erkunden Sie unsere organisierten Kategorien, um Produkte schnell zu finden',
  cat_shoes: 'Schuhe',
  cat_hoodies: 'Hoodies',
  cat_tshirts: 'T-Shirts',
  cat_jackets: 'Jacken',
  cat_pants: 'Hosen',
  cat_headwear: 'Kopfbedeckung',
  cat_sets: 'Sets',
  cat_underwear: 'Unterwäsche',
  cat_jersey: 'Jersey',
  cat_accessories: 'Accessoires',
  cat_bags: 'Taschen',
  cat_belts: 'Gürtel',
  cat_perfumes: 'Parfums',
  cat_other: 'Sonstiges',

  // Benefits
  benefits_title: 'Warum ein CSSBuy Spreadsheet verwenden?',
  benefits_subtitle: 'Entdecken Sie die Vorteile der Organisation Ihrer Produktsuche',
  benefit_1_title: 'Produkte schneller finden',
  benefit_1_text: 'Durchsuchen Sie organisierte Kategorien und finden Sie genau das, was Sie suchen, ohne Zeit zu verlieren.',
  benefit_2_title: 'Links und Kategorien organisieren',
  benefit_2_text: 'Behalten Sie alle Ihre Links und Lieblingsprodukte an einem Ort organisiert.',
  benefit_3_title: 'Informationen vor dem Kauf vergleichen',
  benefit_3_text: 'Greifen Sie auf detaillierte Leitfäden zu und vergleichen Sie Optionen, um fundierte Entscheidungen zu treffen.',
  benefit_4_title: 'QC-Leitfäden und Tipps konsultieren',
  benefit_4_text: 'Lernen Sie, die Produktqualität vor dem Abschluss Ihres Kaufs zu überprüfen.',
  benefit_5_title: 'Versandoptionen besser verstehen',
  benefit_5_text: 'Lernen Sie die verschiedenen Versandmethoden kennen und wählen Sie die beste für Sie.',

  // How It Works
  how_title: 'So funktioniert es',
  how_subtitle: 'Folgen Sie diesen einfachen Schritten, um CSSBuy Spreadsheet optimal zu nutzen',
  step_1: 'Produkt finden',
  step_1_text: 'Durchsuchen Sie die Kategorien und finden Sie Artikel, die Sie interessieren.',
  step_2: 'CSSBuy Spreadsheet konsultieren',
  step_2_text: 'Greifen Sie auf unsere organisierten Ressourcen für weitere Informationen zu.',
  step_3: 'Informationen überprüfen',
  step_3_text: 'Überprüfen Sie Details, Leitfäden und Tipps, bevor Sie fortfahren.',
  step_4: 'QC überprüfen, wenn verfügbar',
  step_4_text: 'Analysieren Sie Qualitätsfotos und Bewertungen, wenn möglich.',
  step_5: 'Versand und Kosten recherchieren',
  step_5_text: 'Verstehen Sie die Versandoptionen und berechnen Sie die Kosten.',
  step_6: 'Vor dem Kauf überprüfen',
  step_6_text: 'Bestätigen Sie alle Informationen, bevor Sie abschließen.',
  step_7: 'Zur Hauptwebsite wechseln',
  step_7_text: 'Besuchen Sie kaspreadsheet.com, um Ihren Kauf abzuschließen.',

  // Safety
  safety_title: 'Sicherheit an erster Stelle',
  safety_text: 'Teilen Sie niemals Ihr Passwort oder Zahlungsdaten mit unbekannten Dritten. Bestätigen Sie immer die Domain, bevor Sie Informationen eingeben. Preise, Produkte und Versandinformationen können sich ändern, daher überprüfen Sie die aktuellen Daten vor dem Kauf.',
  safety_cta: 'Sicherheitsleitfaden anzeigen',

  // Articles
  articles_title: 'Artikel und Leitfäden',
  articles_subtitle: 'Originaler Inhalt, der Ihnen hilft, sich im CSSBuy Spreadsheet zurechtzufinden',
  read_more: 'Mehr lesen',

  // Article card
  article_1_title: 'Was ist CSSBuy Spreadsheet? Ein umfassender Leitfaden für Anfänger',
  article_1_desc: 'Erfahren Sie, wie CSSBuy Spreadsheet funktioniert, wie Sie die organisierten Kategorien verwenden und wie Sie diese Ressource für Ihre Produktsuche optimal nutzen.',
  article_1_date: '28. August 2026',

  // Footer
  footer_disclaimer: 'Diese Website ist eine unabhängige Informationsressource und nicht mit CSSBuy verbunden.',
  footer_privacy: 'Datenschutz',
  footer_terms: 'AGB',
  footer_contact: 'Kontakt',
  footer_copyright: '© 2026 CSSBuy Spreadsheet Resource. Alle Rechte vorbehalten.',

  // Dropdown
  dropdown_title: 'Kategorie auswählen',
  dropdown_all: 'Alle Kategorien',

  // Disclaimer
  disclaimer: 'This website is an independent informational resource and is not affiliated with, operated by, or endorsed by CSSBuy.',

  // CTA buttons
  cta_main_site: 'Hauptwebsite besuchen',
  cta_explore: 'Jetzt erkunden',
  cta_view_products: 'Produkte ansehen',
  cta_title: 'Bereit, das CSSBuy Spreadsheet zu erkunden?',
  cta_subtitle: 'Recherchieren Sie Produkte, konsultieren Sie unsere Leitfäden und finden Sie organisierte Ressourcen, um Ihre Recherche zu erleichtern.',

  // 404
  not_found_title: 'Seite nicht gefunden',
  not_found_text: 'Die gesuchte Seite existiert nicht.',
  not_found_back: 'Zurück zur Startseite',
};